import { FC, useState } from 'react';
import { Blue100, Button, Dropdown, Menu, MenuItem } from '@traceair/tds';
import { PlusIcon } from '@traceair/webapp-icons';
import { GcpExtraCostType } from '../types';

type Props = {
  hasMaterials: boolean;
  hasMileage: boolean;
  onSelect: (type: GcpExtraCostType) => void;
};

// "+ Costs" trigger next to a GCP service item, opening a menu to pick which extra cost
// (GCP Materials / Mileage) to add — already-added ones show disabled. Hidden once both exist.
export const ExtraCostMenuButton: FC<Props> = ({ hasMaterials, hasMileage, onSelect }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (hasMaterials && hasMileage) return null;

  const select = (type: GcpExtraCostType) => {
    onSelect(type);
    setIsMenuOpen(false);
  };

  const menu = (
    <Menu width="160px">
      <MenuItem title="GCP Materials" disabled={hasMaterials} onClick={() => select('materials')} />
      <MenuItem title="Mileage" disabled={hasMileage} onClick={() => select('mileage')} />
    </Menu>
  );

  return (
    <Dropdown
      closeOnOverlayClick
      overlay={menu}
      placement="bottomRight"
      trigger="click"
      open={isMenuOpen}
      onOpenChange={setIsMenuOpen}
    >
      <Button size="xs" text="Costs" style="secondary" icon={<PlusIcon size={14} color={Blue100} />} />
    </Dropdown>
  );
};
